import Cookies from 'universal-cookie';

import { getQueryVar } from './helpers';

const cookies = new Cookies();

export function fetchToken(): string | null {
  let ppToken = cookies.get('pp-token');
  if (!ppToken) {
    ppToken = getQueryVar('token');
  }
  return ppToken;
}
